module.exports = __webpack_public_path__ + "img/index15.0b04b751.png";